import { JSXElement } from '@/common/types';
import { Router } from './router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PrimeReactProvider } from 'primereact/api';
import { queryClient } from './utils/react-query/query-client';
import { env } from './utils/shared/env';

function App(): JSXElement {
    return (
        <PrimeReactProvider>
            <QueryClientProvider client={queryClient}>
                <Router />
                {env.VITE_MODE === 'local' ? <ReactQueryDevtools initialIsOpen={false} /> : null}
            </QueryClientProvider>
        </PrimeReactProvider>
    );
}

export default App;
